import { defineMessage } from 'services/localization';

export const messages = {
    subTotalText: defineMessage('subtotal_1'),
    taxAdjustmentsText: defineMessage('includes_adjustments_to_tax_1'),
    totalAmountText: defineMessage('total_1'),
    taxTypeTextNoTax: defineMessage('amounts_do_not_include_tax'),
    taxTypeTextTaxInclusive: defineMessage('amounts_are_tax_inclusive_1'),
    taxTypeTextTaxExclusive: defineMessage('amounts_are_tax_exclusive_1'),
    invoiceTaxTextTaxInclusive: defineMessage('includes_tax_percent'),
    invoiceTaxTextTaxExclusive: defineMessage('total_tax_percent'),
    cisTaxAmount: defineMessage('cis_deduction_percent_1'),
    remainingCreditAmountText: defineMessage('remaining_credit'),
    allocationText: defineMessage('allocated_to_url'),
};
